const ORBIX_CHECK_CARDS = [
  {
    "subject": "PQR",
    "title": "General Questions",
    "checks": [
      { "text": "Verify the Client Name field contains a recognized company name that matches the asset owner on file for this project." },
      { "text": "Verify the Project field is populated and matches the registered project name in the system." },
      { "text": "Verify the Procedure field identifies a procedure that is approved and active for this project, and that the edition and revision number are correct." },
      { "text": "Verify the Technician who signed the report holds valid certification that was not expired on the date of inspection." },
      { "text": "Verify the Technician Signature field is populated and marked as signed." },
      { "text": "Verify the Date is a valid date, is not in the future, and is logically consistent with the project timeline." },
      { "text": "Verify the Acceptance Criteria is the same acceptance criteria stated in the procedure and the specification." },
      { "text": "If a Filter is used, verify the Filter Type and Filter Placement are authorized for this configuration. If no filter is used, confirm none is required.", "conditional": true },
      { "text": "If a Heat Shield is used, verify the Heat Shield Material, Thickness, and Distance Film-to-Pipe are authorized and consistent with the Exposure Geometry.", "conditional": true },
      { "text": "Verify the Intensifying Screen Material is authorized by the procedure for the radiation type and pipe material being examined." },
      { "text": "Verify the Intensifying Screen Thickness (Front) falls within the allowable range defined in the procedure." },
      { "text": "Verify the Intensifying Screen Thickness falls within the allowable range defined in the procedure." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Radiation Source",
    "checks": [
      { "text": "Verify the Radiation Type is authorized by the procedure for the given pipe material, diameter, and wall thickness." },
      { "text": "Verify the Curie value is acceptable given the specifications." },
      { "text": "Verify the Focal Spot size matches the equipment specified in the procedure and specification." },
      { "text": "Verify the Method (External / Internal) is consistent with the technique prescribed in the procedure." },
      { "text": "Conditional — if Kv and Ma are populated, verify they fall within procedure-defined ranges. If the Radiation Type is GAMMA, confirm these fields are \"N/A\".", "conditional": true }
    ]
  },
  {
    "subject": "PQR",
    "title": "Film Data",
    "checks": [
      { "text": "Verify the Film Type is authorized by the procedure for this examination technique." },
      { "text": "Verify the Film Class meets the minimum requirement defined in the procedure." },
      { "text": "Verify the Film Manufacturer is approved by the procedure." },
      { "text": "Verify the Film Method is consistent with the Radiation Source Method and the viewing technique reported elsewhere on the PQR." },
      { "text": "Verify the Unexposed Base Density falls within the allowable range." },
      { "text": "Verify the Film Width is appropriate for the technique and pipe diameter as defined in the procedure." },
      { "text": "Verify the Film Length is appropriate for the pipe diameter, number of exposures, and coverage requirements." },
      { "text": "Verify the Number of Exposures is correct for the pipe diameter and technique as defined in the procedure." },
      { "text": "Verify the Film Position is consistent with the technique defined in the procedure." },
      { "text": "Verify the Number of Film per Cassette is consistent with the procedure." },
      { "text": "Verify the Readable Length is mathematically consistent with the Film Length and Film Overlap." },
      { "text": "Verify the Film Overlap meets the minimum required by the procedure and asset owner specification." },
      { "text": "Verify the Cassette Separation is appropriate for the Number of Exposures and the pipe diameter." },
      { "text": "Verify both the Exposed Density — Parent Metal and Weld Metal fall within the allowable film density range." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Exposure Geometry",
    "checks": [
      { "text": "Verify the Viewing Technique is consistent with the Film Method and the Radiation Source Method reported elsewhere on the PQR." },
      { "text": "Verify the Source-to-Film Distance is mathematically consistent with the Source-to-Object and Object-to-Film distances." },
      { "text": "Verify the Ug value by recalculating from the reported values on this PQR." },
      { "text": "Verify the Source Offset (in) and Offset Angle (deg) are appropriate for the stated viewing technique." },
      { "text": "Verify the Object-to-Film Distance is consistent with the pipe wall thickness and any additional standoff (such as screens or heat shields)." },
      { "text": "Verify the Number of Exposures Required matches the Number of Exposures reported in the Film Data section." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Exposure Conditions",
    "checks": [
      { "text": "Verify the Total Exposure Time is mathematically consistent with the Single Exposure Time and the Number of Exposures Required." },
      { "text": "Verify the Single Exposure Time falls within the acceptable range for the given source strength, pipe diameter, and wall thickness." },
      { "text": "Conditional — if Curie Minutes is populated, validate the curie-minute calculation. If the Radiation Type is GAMMA and Curie Minutes is \"N/A\", do not flag.", "conditional": true },
      { "text": "Conditional — if X-ray Voltage is populated, verify it falls within the allowable range. If the Radiation Type is GAMMA, confirm this field is \"N/A\".", "conditional": true },
      { "text": "Conditional — if Amperage is populated, verify it falls within the allowable range. If the Radiation Type is GAMMA, confirm this field is \"N/A\".", "conditional": true },
      { "text": "Verify the combination of Exposure Conditions fields is internally consistent with the Radiation Type." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Film Processing",
    "checks": [
      { "text": "Verify the Film Processing Method is consistent with what is prescribed." },
      { "text": "Verify the Develop Time falls within the acceptable range." },
      { "text": "Verify the Develop Temperature falls within the acceptable range." },
      { "text": "Verify the Fix Time meets the minimum requirement." },
      { "text": "Verify the Rinse Time meets the minimum requirement." },
      { "text": "Verify the Final Rinse Time meets the minimum requirement." },
      { "text": "Verify the Drying Detail and Drying Method are consistent with what is prescribed." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Penetrameter (IQI)",
    "checks": [
      { "text": "Verify the Penetrameter Letter Set is correct for this examination configuration." },
      { "text": "Verify the Penetrameter Material is appropriate for the pipe material being examined." },
      { "text": "Verify the Penetrameter ID No. references a recognized and applicable standard." },
      { "text": "Verify the Penetrameter Shim Thickness is appropriate given the IQI Location." },
      { "text": "Verify the IQI Position is consistent with what is prescribed." },
      { "text": "Verify the IQI Location matches what is prescribed." },
      { "text": "Verify the No. per Film meets the minimum requirement." },
      { "text": "Verify the Essential Wire size is correct given the pipe wall or weld thickness." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Pipe Data / Weld Process",
    "checks": [
      { "text": "Verify the Pipe Material is covered by the procedure for this project." },
      { "text": "Verify the Pipe Grade is appropriate for the reported Pipe Material, or that \"N/A\" is acceptable." },
      { "text": "Verify the Pipe Diameter falls within the qualified range of the procedure." },
      { "text": "Verify the Pipe Thickness falls within the qualified range of the procedure." },
      { "text": "Verify the Joint Design is addressed by the procedure." },
      { "text": "Verify the Weld Process is covered by the procedure." },
      { "text": "Verify the Pipe Diameter and Pipe Thickness combination is consistent with the Exposure Geometry and Film Data sections of this PQR." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Letter / Number Belt",
    "checks": [
      { "text": "Verify the Orientation of Markers is consistent with the Number of Exposures and the prescribed marking convention." },
      { "text": "Verify the Manner of Location is consistent with requirements." }
    ]
  },
  {
    "subject": "PQR",
    "title": "Asset Owner Specification Alignment",
    "checks": [
      { "text": "Scan the Asset Owner Specification for any requirements that may be stricter than or in addition to what is defined in the procedure, and verify that this PQR satisfies them." }
    ]
  },
  {
    "subject": "Examination Report",
    "title": "Compliance Audit",
    "checks": [
      { "text": "Verify that the Technician who signed the report holds valid certification that was not expired on the date of inspection." },
      { "text": "Ensure that the examination report is signed by the NDT technician conducting the inspection." },
      { "text": "Ensure the Procedure field is populated and reflecting the correct RT procedure submitted for this project." },
      { "text": "Ensure the Acceptance Criteria field aligns with the procedure and the company specifications." },
      { "text": "Verify that the Diam and Wall fields are populated for every weld entry, and that the diameter and wall thickness combination is a valid pipe size." },
      { "text": "Verify that the Diam and Wall values on this report fall within the allowable range of the relevant PQR." },
      { "text": "Verify that the technique designation (e.g., DWE/SWV) matches the PQR." },
      { "text": "Verify that the No. Exposures Used matches the PQR's requirement for this pipe diameter." },
      { "text": "Verify that the Inside/Outside views field contains a valid integer and matches the PQR's requirement." },
      { "text": "Verify that the Source Type and Source Strength (Curies/KV) match and fall within the allowable range defined in the PQR." },
      { "text": "Verify that Film Density values (Low and High) are populated for each weld entry and fall within the acceptable range defined in the PQR." },
      { "text": "Verify that the Base Density does not exceed the maximum allowable value defined in the PQR or procedure." },
      { "text": "Verify that the Film Type is compatible with the PQR." },
      { "text": "When there is a rejected weld, verify that the defect type is indicated using valid initials and that the defect location is given in inches.", "conditional": true },
      { "text": "Verify that the Accept/Reject decision is not contradicted by the defect entries or the remarks." },
      { "text": "Calculate the sum of the weld entries and verify it matches the \"No. Welds\" summary field." },
      { "text": "Ensure all essential variables in this report align with what is found in the PQR." },
      { "text": "Scan the Welder ID column for any P-prefix or P-suffix entries. For each P-designated weld, verify that a corresponding PQR exists in the system and that the PQR date aligns with the examination report date.", "conditional": true }
    ]
  },
  {
    "subject": "Examination Report",
    "title": "General Accuracy Audit",
    "checks": [
      { "text": "Verify that the Client Name matches the project records." },
      { "text": "Verify that the Project name matches the project records." },
      { "text": "Verify that the Job Number corresponds to this project." },
      { "text": "Verify that the Address / Project Location contains a valid City/State or GPS coordinate. Flag if the field contains generic placeholders like \"On File\" or \"Corporate Address\" instead of the actual job site." },
      { "text": "Verify that the Customer Contact field is populated." },
      { "text": "Verify that the Customer Specification field is populated and aligns with the submitted company specifications." },
      { "text": "Ensure the PO Number box is populated." },
      { "text": "Verify that the Date is valid and not in the future." },
      { "text": "Verify that the Page Number follows the format \"X of Y\" and that all pages are present." }
    ]
  },
  {
    "subject": "Examination Report",
    "title": "Continuity Audit",
    "checks": [
      { "text": "Scan the X-ray Number column. Ensure numbers are sequential without unexplained gaps or duplicates. Compare the start number with the previous report's end number to ensure continuity." },
      { "text": "Verify that the Report No. is sequential relative to the previous report for this specific technician (e.g., if yesterday was Report #8, today must be #9)." },
      { "text": "Verify that Report Numbers increase chronologically with dates." },
      { "text": "Ensure that the Source Curies value is equal to or decreasing from the last report submitted by this technician." },
      { "text": "Scan for duplicate weld entries (same X-ray Number) across all reports in the project." }
    ]
  },
  {
    "subject": "Examination Report",
    "title": "Company Specification Alignment",
    "checks": [
      { "text": "Scan through the company specifications and check if there are any additional reporting or procedural requirements that are not being taken into account on this report." },
      { "text": "If the specification defines stricter limits than the PQR or procedure for any parameter, verify the report meets the stricter limit.", "conditional": true }
    ]
  },
  {
    "subject": "Examination Report",
    "title": "Operational Data Audit",
    "checks": [
      { "text": "Verify that the Unit No. is populated and consistent with previous reports from this technician." },
      { "text": "Verify No. Men on Job is populated and consistent with the personnel listed on the report." },
      { "text": "Verify that the Mileage, Total Hours, Depart From, Per Diem, and ATV Used fields are all populated." }
    ]
  }
];

export default ORBIX_CHECK_CARDS;
